export const LinkTypes = {
    GOOGLE_DRIVE: 'GOOGLE_DRIVE',
    YOUTUBE: 'YOUTUBE',
    BLOB: 'BLOB',
    LOCAL_FILE: 'LOCAL_FILE',
    NONE: 'NONE',
};

export const ReturnCodes = {
    FILE_UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS',
    FILE_UPLOAD_FAILED: 'FILE_UPLOAD_FAILED',
    FOLDER_UPLOAD_SUCCESS: 'FOLDER_UPLOAD_SUCCESS',
    FOLDER_UPLOAD_FAILED: 'FOLDER_UPLOAD_FAILED',
    UNABLE_TO_READ_VERSION: 'UNABLE_TO_READ_VERSION',
    UNABLE_TO_GET_USERS: 'UNABLE_TO_GET_USERS',
    UNABLE_TO_GET_SERVICE_HEALTH: 'UNABLE_TO_GET_SERVICE_HEALTH',
    UNABLE_TO_GET_ISSUES: 'UNABLE_TO_GET_ISSUES',
    UNABLE_TO_REGISTER: 'UNABLE_TO_REGISTER',
    DUPLICATE_EMAIL: 'DUPLICATE_EMAIL',
    SUCCESSUL: 'SUCCESSUL',
    FAILED: 'FAILED',
    OK: 200,
    NON_FOUND: 404,
};